import moment from 'moment';

import {
  PassPseudoStatus,
  PassStatus,
  PassStatusActive,
  PassStatusInactive,
  PassStatusInvitation,
} from '../passes.types';

// Intended usage: use spread operator to prepend.
export const SITE_DEFAULT_OPTION = {
  label: 'All sites',
  value: null,
};

export const SEARCH_END_REASON = {
  /** API returned same or more passes than the limit BEFORE finishing all the fetching steps (1 day, 7 days, etc)*/
  EXCEED_LIMIT: 'exceed_limit',
  /** API returned all passes for all fetch steps (1, 7, 30 and 90 days) given the searchEndedAt limit */
  MAXIMUM_LOOK_BACK: 'maximum_look_back',
  /** API returned all passes for all fetching steps until the final possible searchEndedAt date  */
  PASSES_ALL_LOADED: 'passes_all_loaded',
  /** API returned timeout because searched for too long */
  SEARCH_TIMEOUT: 'search_timeout',
};

export const allSites = SITE_DEFAULT_OPTION.value;

export const PSEUDO_PASS_STATUS_OPTIONS = {
  ARRIVING_SOON: {
    label: 'Arriving soon',
    value: PassStatusInvitation.ARRIVING_SOON,
  },
  FLAGGED: {
    label: 'Flagged',
    value: PassPseudoStatus.WATCHLIST_FLAGGED,
  },
  EXPIRED: {
    label: 'Expired',
    value: PassPseudoStatus.AUTO_EXPIRED,
  },
};

export const PASS_STATUS_OPTIONS = {
  CHECKED_IN: {
    label: 'Checked in',
    value: PassStatus.ACTIVE,
  },
  PENDING: {
    label: 'Pending',
    value: PassStatus.PENDING,
  },
  REJECTED: {
    label: 'Rejected',
    value: PassStatus.REJECTED,
  },
  CHECKED_OUT: {
    label: 'Checked out',
    value: PassStatus.EXPIRED,
  },
};

export const ALL_PASSES_STATUS = Object.keys(PASS_STATUS_OPTIONS).length;

export const ALL_PASS_STATUS_OPTIONS = {
  label: 'All passes',
  value: 'any',
};

export const STATUS_OPTIONS = [
  ALL_PASS_STATUS_OPTIONS,
  PASS_STATUS_OPTIONS.CHECKED_IN,
  PSEUDO_PASS_STATUS_OPTIONS.ARRIVING_SOON,
  PASS_STATUS_OPTIONS.PENDING,
  PSEUDO_PASS_STATUS_OPTIONS.FLAGGED,
  PASS_STATUS_OPTIONS.REJECTED,
  PSEUDO_PASS_STATUS_OPTIONS.EXPIRED,
  PASS_STATUS_OPTIONS.CHECKED_OUT,
];

/** This is required for React Query to know we're dealing with the same query key. */
export const DEFAULT_PASS_FILTERS = {
  siteIds: [],
  limit: 50,
  status: [PassStatusActive.ACTIVE, PassStatusInactive.EXPIRED, PassStatusActive.PENDING, PassStatusInactive.REJECTED],
  deviceTypes: [],
  searchTerm: undefined,
};

/** This is required for React Query to know we're dealing with the same query key. */
export const DEFAULT_INACTIVE_PASS_FILTERS = {
  ...DEFAULT_PASS_FILTERS,
  startDate: moment().subtract(128, 'days').valueOf(),
  endDate: moment().valueOf(),
  status: [PassStatusInactive.EXPIRED, PassStatusInactive.REJECTED],
};

export const DEFAULT_ACTIVE_PASS_FILTERS = {
  ...DEFAULT_PASS_FILTERS,
  limit: 100,
  status: [PassStatusActive.ACTIVE, PassStatusActive.PENDING],
};

export const DATE_RANGE = {
  ALL_TIME: 'all-time',
  TODAY: 'today',
  YESTERDAY: 'yesterday',
  LAST_7_DAYS: 'last-7-days',
  CUSTOM: 'custom',
};

export const DATE_RANGE_OPTIONS = [
  {
    label: 'All time',
    value: DATE_RANGE.ALL_TIME,
  },
  {
    label: 'Today',
    value: DATE_RANGE.TODAY,
  },
  {
    label: 'Yesterday',
    value: DATE_RANGE.YESTERDAY,
  },
  {
    label: 'Last 7 days',
    value: DATE_RANGE.LAST_7_DAYS,
  },
  {
    label: 'Custom range',
    value: DATE_RANGE.CUSTOM,
  },
];

export const DEVICE_TYPE = {
  SINE_POINT: 'SinePoint',
  SINE_WEB: 'SineWeb',
  SINE_TV: 'SineTv',
  MOBILE: 'Mobile',
  WEB_CHECK_IN: 'WebCheckIn',
};

export const DEVICE_TYPE_LABEL = {
  KIOSK: 'Kiosk',
  MOBILE: 'Mobile',
  ADMIN_ENTERED: 'Admin entered',
  WEB_CHECK_IN: 'Web check-in',
};

export const DEVICE_TYPE_OPTIONS = [
  {
    label: DEVICE_TYPE_LABEL.KIOSK,
    key: DEVICE_TYPE.SINE_POINT,
  },
  {
    label: DEVICE_TYPE_LABEL.MOBILE,
    key: DEVICE_TYPE.MOBILE,
  },
  {
    label: DEVICE_TYPE_LABEL.ADMIN_ENTERED,
    key: DEVICE_TYPE.SINE_WEB,
  },
  {
    label: DEVICE_TYPE_LABEL.WEB_CHECK_IN,
    key: DEVICE_TYPE.WEB_CHECK_IN,
  },
];

export const ALERT_PASS_STATUS = {
  BLOCKED_PASS: 'blocked-pass',
  FLAGGED_PASS: 'flagged-pass',
  PASS_NOTES: 'pass-notes',
};
